import { useState } from 'react';

type AccountSettingsModalPhase = 'Form' | 'MFA' | 'Success';

export const useAccountSettingsModalPhase = () => {
  const [phase, setPhase] = useState<AccountSettingsModalPhase>('Form');
  return { phase, setPhase };
};
